const func = ($target) => {
	console.log("miniCartSummary loaded");

	var headerHeight = $('[data-kd-id="header"]').outerHeight();

	$(window)
		.on("scroll", function () {
			var scroll = $(window).scrollTop();

			if (scroll >= headerHeight) {
				$target.addClass("active");
			} else {
				$target.removeClass("active");
			}
		})
		.trigger("scroll");
};

export default func;
